import { useState } from 'react';


import {  textColors } from 'src/constants/wall.constant';
import { socialCardKeys } from 'src/constants/socialcard.constant'
import ClassNames from 'src/components/componentHelper/ClassNames';
import useLazyHlsPlayback from 'src/components/hooks/useLazyHlsPlayback';
// import 'src/assets/css/socialcards.css';


const VideoCard = ({ cardItem, cardWidth, fontStyle, darkModeEnabled=false, cardFontColor, darkCardTheme, smallSize,refresh,isDateTimeDisabled, ratingColor, cardBackgroundObject={}}) => {

   const [containVideo, setContainVideo] = useState(false);
   const [aspectRatio, setAspectRatio] = useState('9 / 16');

   const src = `https://stream.mux.com/${cardItem[socialCardKeys.videoPlaybackId]}.m3u8?default_subtitles_lang=en`;
   const poster = cardItem[socialCardKeys.customThumbnailUrl] || `https://image.mux.com/${cardItem[socialCardKeys.videoPlaybackId]}/thumbnail.jpg?time=1`;
   const { videoRef, isPlaying, isWaiting, togglePlay, handlePlay, handlePlaying, handlePause, handleWaiting, handleEnded } = useLazyHlsPlayback(src);
    
   return (
      <div 
        className={ClassNames(darkModeEnabled?"":"bg-white"," border-none relative z-0 transition-all w-full h-full card-holder ")} 
        style={{ maxWidth: "39rem", cursor: 'default',minWidth:cardWidth,borderRadius:'10px', ...(cardBackgroundObject? cardBackgroundObject :{}) }}>
       

            <div 
            className={ClassNames("relative w-full h-full",(cardItem[socialCardKeys.videoSummary] && cardItem[socialCardKeys.videoSummary]!=='')?'':'overflow-hidden')}
            style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize ? "1.15em" : "1.0em", lineHeight: !smallSize ? 1.5 : 1.7, borderRadius:'10px', backgroundColor:'#000', aspectRatio: aspectRatio}}
            >
             
            <video
     className='rounded-md w-full h-full cursor-pointer'
     style={{borderRadius:'10px',objectFit:containVideo?'contain':'cover',backgroundColor:'#000000'}}
     poster={poster}
     playsInline
     autoPlay={false}
     preload="none"
     onClick={()=>togglePlay()}
     onPlay={handlePlay}
     onPlaying={handlePlaying}
     onPause={handlePause}
     onWaiting={handleWaiting}
     onLoadedMetadata={()=>{
      // if(videoRef && videoRef.current && videoRef.current.videoWidth && videoRef.current.videoHeight){
      //   if(videoRef.current.videoWidth < videoRef.current.videoHeight){
      //     setContainVideo(true);
      //   }
      // }
      refresh();
     }}
     onEnded={handleEnded}
     controlsList={"noremoteplayback"}
     ref={videoRef}
    />

{/* Probes the Mux poster's natural size to reserve the real aspect ratio, then relayouts the grid (reuses the existing onLoad -> refresh() pattern). */}
<img
  src={poster}
  alt=""
  aria-hidden="true"
  style={{display:'none'}}
  onLoad={(e)=>{
    const w = e.target.naturalWidth, h = e.target.naturalHeight;
    if(w && h){ setAspectRatio(`${w} / ${h}`); }
    refresh();
  }}
/>

{
 !isPlaying &&
<div className="absolute bottom-0 transition duration-300 ease-in-out py-2 px-4 w-full opacity-100  bg-gradient-to-t from-black to-transparent ">
  <div className="flex w-full justify-between items-center">

   {/* {
      !isPlaying? */}
        <svg
        onClick={()=>togglePlay()}
                className="h-10 w-10 text-white cursor-pointer"
         width={60} height={60} viewBox="0 0 32 32" fill="none" aria-hidden="true" slot="play">
          <path
            d="M10.6667 6.6548C10.6667 6.10764 11.2894 5.79346 11.7295 6.11862L24.377 15.4634C24.7377 15.7298 24.7377 16.2692 24.3771 16.5357L11.7295 25.8813C11.2895 26.2065 10.6667 25.8923 10.6667 25.3451L10.6667 6.6548Z"
            fill="currentColor"
          />
        </svg>
      {/* :
        <svg 
        onClick={()=>togglePlay()}

                className="h-10 w-10 text-white cursor-pointer"
        viewBox="0 0 32 32" fill="none" aria-hidden="true" slot="pause">
          <path
            d="M8.66667 6.66667C8.29848 6.66667 8 6.96514 8 7.33333V24.6667C8 25.0349 8.29848 25.3333 8.66667 25.3333H12.6667C13.0349 25.3333 13.3333 25.0349 13.3333 24.6667V7.33333C13.3333 6.96514 13.0349 6.66667 12.6667 6.66667H8.66667Z"
            fill="currentColor"
          />{" "}
          <path
            d="M19.3333 6.66667C18.9651 6.66667 18.6667 6.96514 18.6667 7.33333V24.6667C18.6667 25.0349 18.9651 25.3333 19.3333 25.3333H23.3333C23.7015 25.3333 24 25.0349 24 24.6667V7.33333C24 6.96514 23.7015 6.66667 23.3333 6.66667H19.3333Z"
            fill="currentColor"
          />
        </svg>
   }   */}
     <div className={ClassNames("flex flex-col text-white items-end",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')}>
      <p className="text-lg font-semibold" style={{textAlign:'end'}}>{cardItem[socialCardKeys.authorName]}</p>
      <a 
        href={ (cardItem[socialCardKeys.messageLink] && cardItem[socialCardKeys.messageLink]!=='' )? cardItem[socialCardKeys.messageLink] : void(0)} 
        target={(cardItem[socialCardKeys.messageLink] && cardItem[socialCardKeys.messageLink]!=='' )?"_blank":"_self"} 
        rel="noreferrer noopener" 
        className={ClassNames("text-base",(cardItem[socialCardKeys.messageLink] && cardItem[socialCardKeys.messageLink]!=='' )?'hover:underline customs':'no-underline')} 
        style={{textAlign:'end', color: 'inherit'}}>
          {cardItem[socialCardKeys.workTitle]}
        </a>
    </div>
  </div>
</div> 
  }
{
   isWaiting &&
<svg
    version={1.0}
    width="45px"
    height="45px"
    viewBox="0 0 128 128"
    xmlSpace="preserve"
    className='absolute inset-0 m-auto'
  >
    <g>
      <path
        d="M70.1 9.42l-10.7 9.4v-5.77a50.82 50.82 0 0 0-43.7 68.23L11 79.7l-1.5 5.53A58 58 0 0 1 59.4 5.8V0z"
        fill="#F3F4F6"
      />
      <path
        d="M70.1 9.42l-10.7 9.4v-5.77a50.82 50.82 0 0 0-43.7 68.23L11 79.7l-1.5 5.53A58 58 0 0 1 59.4 5.8V0z"
        fill="#F3F4F6"
        transform="rotate(120 64 64)"
      />
      <path
        d="M70.1 9.42l-10.7 9.4v-5.77a50.82 50.82 0 0 0-43.7 68.23L11 79.7l-1.5 5.53A58 58 0 0 1 59.4 5.8V0z"
        fill="#F3F4F6"
        transform="rotate(240 64 64)"
      />
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 64 64"
        to="120 64 64"
        dur="240ms"
        repeatCount="indefinite"
      />
    </g>
  </svg>
}

            </div>
            {
              cardItem && cardItem[socialCardKeys.videoSummary] && cardItem[socialCardKeys.videoSummary]!=='' &&
              <div className="px-5 py-4 rounded-md shadow-md text-left" style={!darkModeEnabled ? {  color: (cardFontColor || textColors.black.primary), fontSize: !smallSize ? "1.15em" : "1.0em", lineHeight: !smallSize ? 1.5 : 1.7, textDecoration: 'none' } : {  color: (cardFontColor || textColors.light.primary), fontSize: !smallSize ? "1.15em" : "1.0em", lineHeight: !smallSize ? 1.5 : 1.7, textDecoration: 'none' }}>
              <q className={ClassNames("italic", fontStyle && fontStyle !== '' ? `font-${fontStyle}` : '')} style={{ display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {cardItem[socialCardKeys.videoSummary]}
              </q>
            </div>
          }
      
      
         </div>
   )
}

export default VideoCard;
